import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'emailDelivery';

export const actionTypes = {
  GET_EMAIL_DELIVERY_DATA: `${FEATURE_NAME}/GET_EMAIL_DELIVERY_DATA`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
